import { Routes } from '@angular/router';

export const AUTH_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/authorization/authorization.component').then((m) => m.AuthorizationComponent),
    title: 'Authorization',
  },
  {
    path: 'login',
    loadComponent: () => import('./components/lead-form/lead-form.component').then((m) => m.LeadFormComponent),
    title: 'Login',
  },
  {
    path: 'google-callback',
    loadComponent: () => import('./components/callback/callback.component').then((m) => m.CallbackComponent),
    title: 'Login',
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
